;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();import type { StocklistSourceInfoSchema } from '@qogita/canary-client/sellers'
import { Badge } from '@qogita/ui/v2/badge'
import { ButtonIcon } from '@qogita/ui/v2/button-icon'
import { Icon } from '@qogita/ui/v2/icon'
import { formatDistanceToNowStrict } from 'date-fns'
import { AnchorWithSignature } from 'src/deprecated/components/shared/AnchorWithSignature'

export function DownloadInsightsCard({
  selectedStocklistSource,
  origin,
}: {
  selectedStocklistSource: StocklistSourceInfoSchema
  origin?: string
}) {
  return (
    <div className="border-default bg-default flex h-full flex-col gap-6 rounded-lg border p-6 shadow-xs">
      <div className="text-high-emphasis flex flex-col gap-4">
        <div className="flex items-start justify-between gap-2">
          <h3 className="typography-header-lg-bold">
            Download {selectedStocklistSource.name} pricing report
          </h3>
          <Badge
            emphasis="high"
            variant="marketing"
            size="small"
            // oxlint-disable-next-line shadcn/no-restyle -- grandfathered: pre-rollout restyle className on v2 component
            className="uppercase"
          >
            New
          </Badge>
        </div>
        <p className="typography-body-sm-normal">
          Export sales, pricing and inventory data for every product in this
          price list, straight to Excel.
        </p>
      </div>

      <div className="mt-auto flex flex-col gap-3 lg:flex-row lg:items-center">
        <AnchorWithSignature
          variant="contained"
          size="small"
          className="self-start"
          href={`/sellers/insights/${selectedStocklistSource.qid}/download/`}
          rumActionName="Download inventory pricing report"
          rumData={{
            stockType: selectedStocklistSource.stockType,
            ...(origin ? { origin } : {}),
          }}
        >
          <ButtonIcon name="heroicons/solid/arrow-down-tray" />
          Download
        </AnchorWithSignature>

        <div className="flex flex-wrap items-center gap-3">
          {selectedStocklistSource.insightsLastGeneratedAt ? (
            <span className="typography-body-xs-normal text-low-emphasis inline-flex items-center gap-1">
              <Icon name="heroicons/outline/clock" className="size-4" />
              Last generated:{' '}
              {formatDistanceToNowStrict(
                new Date(selectedStocklistSource.insightsLastGeneratedAt),
                { addSuffix: true },
              )}
            </span>
          ) : null}
          <span className="typography-body-xs-normal text-low-emphasis inline-flex items-center gap-1">
            <Icon name="heroicons/outline/document-text" className="size-4" />
            Excel format
          </span>
        </div>
      </div>
    </div>
  )
}
